import { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Loader from "../../../../common/loader/Loader";

import { POST } from "../../../../utils/fetchUtil";
import { MessageContext } from "../../../../common/message/index";

import "./CustomConfirmVoteModal.scss";

const CustomConfirmVoteModal = ({ active, selectedCandidate, setModalActive, id }) => {
  const { t } = useTranslation();
  const message = useContext(MessageContext);
  const [width, setWidth] = useState(window.innerWidth);
  const [isLoading, setIsLoading] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const history = useHistory();

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  const isMobile = width <= 960;

  // Turn on/off modal
  if (!active) {
    return null;
  }

  const arrayOfCandidates = Array.isArray(selectedCandidate);

  const handleCloseBtn = () => {
    setModalActive(false);

    message.toggle({
      title: t("voting.votingMsg.admonishment"),
      content: t("voting.votingMsg.votingQuitclaim"),
      hideNo: false,
      noLabel: t("modalMessage.noLabel"),
      yesLabel: t("modalMessage.yesLabel"),
      onYes: () => {
        message.toggle({});
      },
      onNo: () => {
        message.toggle({});
        setModalActive(true);
      },
    });
  };

  const vote = () => {
    setIsLoading(true);
    setModalActive(true);
    POST(
      "/vote",
      { electionId: id, votes: selectedCandidate },
      (response) => {
        setModalActive(false);
        setIsLoading(false);
        message.toggle({
          title: t("voting.votingMsg.admonishment"),
          content: response,
          hideNo: true,
          yesLabel: t("modalMessage.OKLabel"),
          onYes: () => {
            message.toggle({});
            history.push(`/elections`);
          },
        });
      },

      (err) => {
        message.toggle({
          title: t("modalMessage.titleError"),
          content: err,
          hideNo: true,
          yesLabel: t("modalMessage.OKLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
  };

  // Dovrsiti network req.
  const handleConfirmBtn = () => {
    if (selectedCandidate) {
      setIsLoading(true);

      vote();
    } else {
      alert("Odabran kandidat ne postoji!");
      setModalActive(false);
    }
  };

  const mainModalContent = (
    <>
      <div className="content">
        <div>
          <h2 className="confirm-modal-mobile-header">{t("voting.candidatesContent.uChoose")}</h2>
        </div>
        {arrayOfCandidates ? (
          selectedCandidate.map((candidate, index) => {
            if (Object.keys(candidate).length !== 0) {
              return (
                <div
                  key={index}
                  className="p-3 confirm-modal-mobile-p has-text-centered has-text-weight-bold is-size-5"
                >
                  {candidate.nameAndSurname}
                </div>
              );
            }
          })
        ) : (
          <div className="p-5 confirm-modal-mobile-p has-text-centered has-text-weight-bold is-size-5">
            {selectedCandidate.nameAndSurname}
          </div>
        )}

        <div className="p-5 has-text-centered">
          <p className="confirm-modal-mobile-p is-size-5">
            {t("voting.votingMsg.confirmationTxt")}
          </p>
        </div>
      </div>
      <div className="has-text-centered">
        <button
          className="button is-outlined ml-2 confirm-modal-vote-btn"
          id="closebtn"
          onClick={handleCloseBtn}
        >
          {t("voting.votingMsg.cancel")}
        </button>
        <button
          className="button is-success ml-2 confirm-modal-vote-btn"
          id="previous"
          onClick={handleConfirmBtn}
        >
          {t("voting.votingMsg.confirm")}
        </button>
      </div>
    </>
  );

  return (
    <div id="modal" className={isMobile ? "modal is-active p-4" : "modal is-active"}>
      <div className="modal-background"></div>
      <div className="modal-content">
        <div className="box">
          <article className="media">
            <div className="media-left"></div>
            <div style={{ overflow: "hidden" }} className="media-content">
              {/* If POST in progress, set loading spinner. Upon successful POST, display msg for 3 sec. */}
              {isLoading ? (
                <>
                  <Loader size={`6x`} className="is-flex-grow-1 is-align-self-center" />
                </>
              ) : isCompleted ? (
                <h2 className="has-text-centered m-0">Glasovanje uspješno!</h2>
              ) : (
                mainModalContent
              )}
            </div>
          </article>
        </div>
      </div>
    </div>
  );
};

export default CustomConfirmVoteModal;
